import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "views/shop/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import ShopSidebar from "components/Sidebar/ShopSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import Events from 'views/examples/ticketing/Events'
import Cart from 'views/examples/ticketing/EventsCart'

import CheckPermission from "variables/CheckPermission";
import NewPass from "components/Reusable Components/NewPass";
import TicketShop from "views/examples/ticketing/TicketShop";
import VipTablesReport from "views/examples/ticketing/VipReports";
import SimpleShop from "views/examples/merchShop/SimpleShop";
import EventsMedia from "views/examples/ticketing/EventsMedia";
import SellerPermissions from "views/examples/ticketing/SellerPermissions";
import CreateNewUser from "views/examples/CreateNewUser";
import UsersTable from "views/examples/UsersTable";
import EventSales from "views/examples/ticketing/EventSales";

const Shop = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));
  const role = JSON.parse(localStorage.getItem("user")).role;

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/shop/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/shop/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/shop":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/shop/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/shop/events":
        Comp=Events;
        title='Events';
        break; 
      case "/shop/newpass":
        Comp=NewPass;
        title='Events';
        break; 
      case "/shop/events/cart":
        Comp=Cart;
        title='Cart';
        break;
      case "/shop/events/media":
        Comp=EventsMedia;
        title='Media';
        break;
      case "/shop/events/shop":
        Comp=TicketShop;
        title='Ticket Shop';
        break;
      case "/shop/events/reports/vip":
        Comp=VipTablesReport;
        title='Vip Table Report';
        break;
      case "/shop/events/permissions":
        Comp=SellerPermissions;
        title='Seller Permissions';
        break;
      case "/shop/merchshop":
        Comp=SimpleShop;
        title='Merchandise Shop';
        break;
      case "/shop/new/user":
        Comp=CreateNewUser;
        title='Add New User';
        break;
      case "/shop/users":
          Comp=UsersTable;
          title='All Users';
          break;
      case "/shop/events/reportsales":
          Comp=EventSales;
          break;
  }



  return permission ? <>
              
              <ShopSidebar
                pic={pic}
                logo={{
                  innerLink: "/" + role + "/index",
                  imgSrc: require("../../assets/img/brand/argon-react.png").default,
                  imgAlt: "..."
                }}/>
              <div className="main-content mt-4">
                <CleanNavbar title={title} />
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default Shop;
